import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
// Axios Imports
import axios from '@src/service/axios';
import { toast } from 'react-toastify';

export const addNotes = createAsyncThunk('notesSlice/addNotes', async (data) => {
    try {
        let response = await axios.post('/sticky-notes', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message);
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message);
        return Promise.reject(err);
    }
});

export const getNotes = createAsyncThunk('notesSlice/getNotes', async (data) => {
    try {
        let response = await axios.get('/sticky-notes', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message);
        return Promise.reject(err);
    }
});
export const updateNotes = createAsyncThunk('notesSlice/updateNotes', async ({ id, title, description }) => {
    try {
        let response = await axios.put(
            '/sticky-notes/' + id,
            {
                title,
                description
            },
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        toast.success(response?.data?.message);
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message);
        return Promise.reject(err);
    }
});

export const deleteNotes = createAsyncThunk('notesSlice/deleteNotes', async (id) => {
    try {
        let response = await axios.delete('/sticky-notes/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message);
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message);
        return Promise.reject(err);
    }
});

export const notesSlice = createSlice({
    name: 'notesSlice',
    initialState: {
        notesData: []
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getNotes.fulfilled, (state, action) => {
            state.notesData = action.payload;
            return;
        });
    }
});

export default notesSlice.reducer;
